import { differenceInDays, parseISO } from 'date-fns'

export function withinOnboardingWindow(company, days = 30) {
  if (!company || !company.created_at) {
    return false
  }

  return differenceInDays(new Date(), parseISO(company.created_at)) <= days
}
